import { HttpEvent, HttpEventType, HttpResponse, HttpUploadProgressEvent } from '@angular/common/http';
import { ModelSignal, linkedSignal } from '@angular/core';

import { CoverImage } from '../model/product/general';

export function isNonAngularUrl(redirectTo: string) {
  if (!redirectTo) return false;
  if (redirectTo === '/') return false;
  if (redirectTo.startsWith('v4/')) return false;
  return !redirectTo.startsWith('/v4');
}

export function buildV3Url(redirectTo: string) {
  return `/_/${redirectTo}`;
}

export const isProgressEvent = (e: HttpEvent<unknown>): e is HttpUploadProgressEvent =>
  e.type === HttpEventType.UploadProgress;

export const isResponse = (e: HttpEvent<unknown>): e is HttpResponse<unknown> => e.type === HttpEventType.Response;

export const mapImageIdToObjectURL = (images: ModelSignal<CoverImage[]>) =>
  linkedSignal<CoverImage[], Record<string, string>>({
    source: images,
    computation: (images, previous) => {
      const oldRecord = previous?.value || {};
      const newRecord: Record<string, string> = {};

      Object.entries(oldRecord).forEach(([id, url]) => {
        if (images.every((img) => img.id !== id)) {
          URL.revokeObjectURL(url);
        }
      });

      images.forEach(({ id, file }) => {
        if (oldRecord[id]) {
          newRecord[id] = oldRecord[id];
        } else if (file) {
          newRecord[id] = URL.createObjectURL(file);
        }
      });

      return newRecord;
    },
    equal: (a, b) => {
      const bKeys = Object.keys(b);

      if (bKeys.length !== Object.keys(a).length) {
        return false;
      }

      return bKeys.every((bK) => a[bK]);
    },
  });
